import { useEffect, useRef, useState } from "react";
import { newLivePoint } from "../../../shared/live-moments";
import type { GameState, PointEvent } from "../../../shared/types";

export function useScoringMoment(state: GameState, connected: boolean, skew: number) {
  const previous = useRef<GameState | null>(null);
  const seen = useRef({ match: "", points: new Set<string>() });
  const [point, setPoint] = useState<PointEvent | null>(null);
  useEffect(() => {
    const reset = () => {
      previous.current = null;
      setPoint(null);
    };
    document.addEventListener("visibilitychange", reset);
    return () => document.removeEventListener("visibilitychange", reset);
  }, []);
  useEffect(() => {
    const match = `${state.fieldId}:${state.scheduleGameId}:${state.teamA.teamId}:${state.teamB.teamId}`;
    if (seen.current.match !== match) seen.current = { match, points: new Set() };
    const candidate =
      connected && document.visibilityState !== "hidden"
        ? newLivePoint(previous.current, state, Date.now() + skew)
        : null;
    const signature = (p: PointEvent) => `${p.at}:${p.team}:${p.scoreA}:${p.scoreB}`;
    const next = candidate && !seen.current.points.has(signature(candidate)) ? candidate : null;
    for (const p of state.points ?? []) seen.current.points.add(signature(p));
    previous.current = connected ? state : null;
    setPoint(next);
    if (!next) return;
    const timer = window.setTimeout(() => setPoint(null), 1200);
    return () => window.clearTimeout(timer);
  }, [state, connected, skew]);
  return point;
}
